import React from 'react';
import { motion } from 'framer-motion';
import { Button, WHATSAPP_URL } from './ui/Button';
const services = [{
  id: 1,
  title: 'Tratamientos Faciales',
  description: 'Limpieza profunda, hidratación intensiva y protocolos anti-age para una piel radiante.',
  image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?q=80&w=2070&auto=format&fit=crop',
  size: 'large' // Takes up more space in grid
}, {
  id: 2,
  title: 'Tratamientos Corporales',
  description: 'Modelado, drenaje linfático y radiofrecuencia para esculpir tu figura.',
  image: 'https://images.unsplash.com/photo-1519823551278-64ac92734fb1?q=80&w=2070&auto=format&fit=crop',
  size: 'small'
}, {
  id: 3,
  title: 'Depilación Definitiva',
  description: 'Tecnología láser de última generación para una piel suave todo el año.',
  image: 'https://images.unsplash.com/photo-1552693673-1bf958298935?q=80&w=2072&auto=format&fit=crop',
  size: 'small'
}, {
  id: 4,
  title: 'Tratamientos Especiales',
  description: 'Peeling, mesoterapia y vitaminas personalizadas según tus necesidades.',
  image: 'https://images.unsplash.com/photo-1611625618313-68b87aaa0626?q=80&w=1964&auto=format&fit=crop',
  size: 'medium'
}];
export function Services() {
  return <section id="servicios" className="py-24 bg-nude relative bg-noise" data-id="element-187">
      <div className="container mx-auto px-6 md:px-12" data-id="element-188">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-189">
          <div className="max-w-2xl" data-id="element-190">
            <motion.span initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} className="text-rosegold text-sm font-sans uppercase tracking-[0.2em] mb-4 block" data-id="element-191">
              Nuestra Especialidad
            </motion.span>
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-4xl md:text-5xl font-serif text-deepblack" data-id="element-192">
              Nuestros <span className="italic font-light" data-id="element-193">Tratamientos</span>
            </motion.h2>
          </div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-194">
            <Button href={WHATSAPP_URL} variant="outline" data-id="element-195">
              Consultar catálogo completo
            </Button>
          </motion.div>
        </div>

        {/* Editorial Asymmetric Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 auto-rows-[300px] md:auto-rows-[400px]" data-id="element-196">
          {services.map((service, index) => {
          // Determine grid span based on size
          let spanClasses = 'md:col-span-6';
          if (service.size === 'large') spanClasses = 'md:col-span-7 md:row-span-2';
          if (service.size === 'medium') spanClasses = 'md:col-span-5 md:row-span-2';
          if (service.size === 'small') spanClasses = 'md:col-span-6 md:row-span-1';
          return <motion.div key={service.id} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.7,
            delay: index * 0.1
          }} className={`relative group overflow-hidden rounded-2xl ${spanClasses}`} data-id="element-197">
                <img src={service.image} alt={service.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" data-id="element-198" />
                <div className="absolute inset-0 bg-gradient-to-t from-deepblack/80 via-deepblack/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500" data-id="element-199"></div>

                <div className="absolute inset-0 p-8 flex flex-col justify-end" data-id="element-200">
                  <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-201">
                    <h3 className="text-2xl md:text-3xl font-serif text-white mb-3" data-id="element-202">
                      {service.title}
                    </h3>
                    <p className="text-white/80 font-sans text-sm md:text-base font-light mb-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100 max-w-md" data-id="element-203">
                      {service.description}
                    </p>
                    <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-rosegold font-sans text-sm uppercase tracking-widest hover:text-white transition-colors" data-id="element-204">
                      Agendar <span className="ml-2" data-id="element-205">→</span>
                    </a>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}